import styled from 'styled-components';
import { TIMING } from '../Templates/template.utils';

export type ModalBorderRadius = 'medium' | 'small';

export const JRCModalBox = styled.div<{
    position?: 'right' | 'left';
    open?: boolean;
    inplace?: boolean;
    offsetTop?: number;
    zIndex?: number;
}>`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: ${({ inplace, offsetTop }) => (offsetTop !== undefined ? `${offsetTop}px` : inplace ? '0' : 'initial')};
    ${({ inplace }) =>
        !inplace &&
        `
        bottom: 0;
    `}
    ${(props) =>
        props.position === 'left'
            ? `
        left:0;
        border-right: solid 1px ${props.theme.color.grey2};
        `
            : `
        right:0;
        border-left: solid 1px ${props.theme.color.grey2};
        `}
    background-color: white;
    z-index: ${(props) => props.zIndex ?? props.theme.zIndex.sidePanelModal};
    overflow: scroll;
    width: min(max(30vw, 600px), 100vw);
    min-height: ${({ offsetTop }) => (offsetTop ? 'initial' : '100%')};
    transition: margin ${TIMING}ms;
    ${(props) => !props.open && `margin-${props.position === 'left' ? 'left' : 'right'}: -100%;`};
`;

export const JRCModalTitle = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const JRCModalOptions = styled.div``;

export const JRCModalContent = styled.div<{ removePadding?: boolean }>`
    padding: ${(props) => (props.removePadding ? 0 : '0px 24px 0 24px')};
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const JRCModalHeader = styled.div<{ removePadding?: boolean }>`
    z-index: 10;
    flex-shrink: 0;
    min-height: 16px;
    height: 54px;
    padding: 0 16px;
    margin-bottom: ${(props) => (props.removePadding ? 0 : '2em')};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 1px ${(props) => props.theme.color.grey2};
    position: sticky;
    top: 0;
    background-color: ${({ theme }) => theme.color.white};
`;

export const JRCModalFooter = styled.div`
    flex-shrink: 0;
    padding: 24px;
    z-index: 0;
    margin-top: 2em;
    border-top: solid 1px ${(props) => props.theme.color.grey2};
    display: flex;
    justify-content: flex-end;
`;

export const JRCModalClose = styled.div``;
